/**
 * @param array | required
 *
 * Example:
 *
 * preloadImages(['../logo.png', '../logo-2.png']);
 */

const LoadImages = (images) => {
  let imagesLoaded = []

  images.forEach((image, i) => {
    imagesLoaded[i] = new Image().src = image
  })

  return imagesLoaded
}

const PreloadImages = (images) => {
  if (!images.length > 0) return

  return LoadImages(images)
}

export default PreloadImages
